export const isInputValid = (value: string) => {
  if (!value) return true;
  return isFinite(parseFloat(value)) && /^\d+(\.\d+)?$/.test(value);
};
